module.exports = __webpack_public_path__ + "media/images/icon-192x192-v2-a3b62ad81a1ecdfc7517aca9eca83496.png";